import { ContactType_Enum } from '@weave/schema-gen-ts/dist/shared/persons/v3/enums.pb';

export const SUFFIX_OPTIONS = [
  { label: 'Jr.', value: 'jr' },
  { label: 'Sr.', value: 'sr' },
  { label: 'I', value: 'i' },
  { label: 'II', value: 'ii' },
  { label: 'III', value: 'iii' },
  { label: 'IV', value: 'iv' },
];

export const PHONE_TYPE_OPTIONS = [
  { label: 'Mobile', value: ContactType_Enum.PHONE_MOBILE },
  { label: 'Home', value: ContactType_Enum.PHONE_HOME },
  { label: 'Work', value: ContactType_Enum.PHONE_WORK },
];

export const HOUSING_STATUS_OPTIONS = [
  { label: 'Own', value: 'O' },
  { label: 'Rent', value: 'R' },
  { label: 'Other', value: 'L' },
];

export const ID_TYPE_OPTIONS = [
  { label: 'State Issued ID', value: 'STATE_ID' },
  { label: "Driver's License", value: "DRIVER'S_LICENSE" },
  { label: 'US Passport', value: 'PASSPORT' },
  { label: 'Foreign Passport', value: 'VISA_NUMBER' },
  { label: 'Military ID', value: 'MILITARY_ID' },
  { label: 'Tribal ID', value: 'TRIBAL_ID' },
  { label: 'Green Card / Resident Alient Card', value: 'PERMANENT_RESIDENT_CARD/GREEN_CARD' },
  { label: 'Government Issued ID', value: 'government_id' },
] as const;

export type IdTypeOptionValues = (typeof ID_TYPE_OPTIONS)[number]['value'];

export const stateRequiredTypes: IdTypeOptionValues[] = ['STATE_ID', "DRIVER'S_LICENSE"];
export const militaryBranchRequiredTypes: IdTypeOptionValues[] = ['MILITARY_ID'];
export const countryRequiredTypes: IdTypeOptionValues[] = ['VISA_NUMBER'];
